export default "__VITE_ASSET__DI$8UqNZ__"